import React, { PureComponent } from 'react';
import { withNamespaces } from 'react-i18next';
import { NavLink } from 'react-router-dom';
import classnames from 'classnames';
import Icon from '@mynewsdesk/ui/lib/Icon';

class LoggedInMenuMobile extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      isMenuOpen: false,
    };
  }

  toggleMenu = () => {
    this.setState({
      isMenuOpen: !this.state.isMenuOpen,
    });
  };

  logout = () => {
    this.toggleMenu();
    this.props.logout();
  };

  isActive = (match, location) =>
    location.pathname === '/' ||
    location.pathname === '/stories' ||
    location.pathname === '/organisations';

  alertsIsActive = (match, location) =>
    location.pathname === '/alerts' || location.pathname === '/following';

  render() {
    const {
      t,
      isJournalist,
      site,
      userId,
      isPressOfficer,
      isAdmin,
    } = this.props;

    const domain = window.location.hostname.replace(/^www\./, '');
    const sitePath = site.code === 'com' ? '' : site.path;
    const helpCenterSitePath = site.localized.helpCenter
      ? `/${site.defaultLocale}`
      : '/en';

    return (
      <div>
        <button
          onClick={this.toggleMenu}
          className="mnd-mobile-menu__open-button"
        >
          <span className="screen-reader-only">Toggle</span>
          <i className="fas fa-bars" />
        </button>
        <div
          className={classnames('mnd-mobile-menu', {
            open: this.state.isMenuOpen,
          })}
        >
          <button
            onClick={this.toggleMenu}
            className="mnd-mobile-menu__close-button"
          >
            <span className="screen-reader-only">Toggle</span>
            <i className="fas fa-times" />
          </button>
          <ul className="mnd-navigation-menu">
            <li className="mnd-navigation-menu__item">
              <NavLink
                to={{
                  pathname: '/',
                }}
                isActive={this.isActive}
                activeClassName="mnd-navigation-menu__item-hitarea--active"
                className="mnd-navigation-menu__item-hitarea mnd-button--link"
                onClick={this.toggleMenu}
              >
                {t('common_navigation-menu_title-stories')}
              </NavLink>
            </li>
            <li className="mnd-navigation-menu__item">
              <NavLink
                to={{
                  pathname: '/alerts',
                }}
                isActive={this.alertsIsActive}
                activeClassName="mnd-navigation-menu__item-hitarea--active"
                className="mnd-navigation-menu__item-hitarea mnd-button--link"
                onClick={this.toggleMenu}
              >
                {t('common_navigation-menu_title-subscriptions')}
              </NavLink>
            </li>
            {(isPressOfficer || isAdmin) && (
              <li className="mnd-navigation-menu__item">
                <a
                  href={`https://publish.${domain}`}
                  rel="noopener noreferrer"
                  className="mnd-navigation-menu__item-hitarea mnd-button--link track-header"
                >
                  {t('navigation_loggedin_dashboard')}
                </a>
              </li>
            )}
            <li className="mnd-navigation-menu__item-separator" />
            <li className="mnd-navigation-menu__item">
              <a
                href={`/profile/${userId}/settings`}
                className="mnd-navigation-menu__item-hitarea mnd-button--link track-header"
              >
                {t('navigation_loggedin_user-settings')}
              </a>
            </li>
            {isJournalist && !isPressOfficer && (
              <li className="mnd-navigation-menu__item">
                <a
                  href={`${sitePath}/journalist`}
                  className="mnd-navigation-menu__item-hitarea mnd-button--link track-header"
                >
                  {t('navigation_loggedin_get-mynewsdesk')}
                </a>
              </li>
            )}
            <li className="mnd-navigation-menu__item">
              <a
                href={`/profile/${userId}/edit`}
                className="mnd-navigation-menu__item-hitarea mnd-button--link track-header"
              >
                {t('navigation_loggedin_profile')}
              </a>
            </li>
            <li className="mnd-navigation-menu__item">
              <a
                href={`${sitePath}/library/`}
                className="mnd-navigation-menu__item-hitarea mnd-button--link track-header"
              >
                {t('global_footer-menu_library')}
              </a>
            </li>
            <li className="mnd-navigation-menu__item">
              <a
                href={`https://help.mynewsdesk.com${helpCenterSitePath}/`}
                className="mnd-navigation-menu__item-hitarea mnd-button--link track-header"
              >
                {t('global_footer-menu_help-support')}
              </a>
            </li>
            <li className="mnd-navigation-menu__item-separator" />
            {isAdmin && (
              <>
                <li className="mnd-navigation-menu__item">
                  <a
                    href={'/admin'}
                    className="mnd-navigation-menu__item-hitarea mnd-button--link track-header"
                  >
                    Admin
                  </a>
                </li>
                <li className="mnd-navigation-menu__item-separator" />
              </>
            )}
            <li className="mnd-navigation-menu__item">
              <button
                className="mnd-navigation-menu__item-hitarea "
                onClick={this.logout}
              >
                {t('navigation_log-out')}{' '}
                <Icon icon={['fas', 'sign-out-alt']} />
              </button>
            </li>
          </ul>
        </div>
      </div>
    );
  }
}

export default withNamespaces()(LoggedInMenuMobile);
